<template>
  <v-list v-if="isSideBarListDisplay" class="menu-collection">
    <v-list-item
      @click="
        () => {
          $store.commit('setMobileNavText', $t('sideBar.seeAll'));
          $store.commit('toggleMenu');
        }
      "
      :class="mode"
      :to="{ path: `/${mode}` }"
      tag="router-link"
    >
      <v-list-item-title
        >{{ $t(`sideBar.${mode}.showAll`) }}<span> | </span>
        {{ mode === "finances" ? count : statusesCountSum }}</v-list-item-title
      >
    </v-list-item>
    <v-list-item
      v-for="status in Statuses"
      :key="status.id"
      :to="{ path: `/${mode}/` + status.id }"
      :class="mode"
      tag="router-link"
      @click="
        () => {
          $store.commit('setMobileNavText', status.name);
          $store.commit('toggleMenu');
        }
      "
    >
      <v-list-item-title>
        {{ isLangHebrew ? status.name : status.enName }}<span> | </span
        >{{ isNaN(status.count) ? "" : status.count }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    Statuses: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    isSideBarListDisplay: {
      type: Boolean,
      required: true,
    },
    count: {
      type: Number,
      required: false,
    },
    selectedBgColor: {
      type: String,
    },
  },
  computed: {
    statusesCountSum() {
      if (!this.Statuses) return;
      // console.log(this.Statuses);
      const statusesKeys = Object.keys(this.Statuses);
      console.log(statusesKeys);
      return statusesKeys.reduce((sum, statusKey) => {
        return sum + this.Statuses[statusKey].count;
      }, 0);
    },
    isLangHebrew() {
      return this.getUserLang == "he" ? true : false;
    },
    ...mapGetters({
      getUserLang: "AuthModule/getUserLang",
    }),
  },
};
</script>

<style scoped lang="scss">
.v-list {
  color: white !important;
}
.cart.v-list-item--active {
  background: #35bae0;
}
.orders.v-list-item--active {
  background: #44a5e233;
}
.finances.v-list-item--active {
  background: #29c4d033;
}
.invoices-and-returns {
  background: #89d1ff8a;
}

.menu-collection {
  .v-list-item-title {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    color: $statusListColor;
  }
}
</style>
